import React, { Component } from 'react';
import { TextInput, PrimaryButton, SelectInput } from '../../components/BasicForm';
import { DateField } from '../../components/DateField';
import { DualRangeInput } from'../../components/DualRangeInput';
import { OffenderResultCard } from '../../components/OffenderResultCard';
import { LoadingIndicator } from '../../components/LoadingIndicator';
import { ErrorDisplay } from '../../components/ErrorDisplay';
import { DateUtils } from 'react-day-picker';
import { RangeSlider } from '../../components/RangeSlider';
import SelectFieldOptions  from '../../utils/selectFieldOptions';
import axios from 'axios';
import moment from 'moment';
import 'rc-slider/assets/index.css';

class OffenderToVisit extends Component {
	state = {
		heading: 'Select Who to Visit',
		showProgressBar: true,
		badge: 25,
		pageId: 'visitor-who-to-visit',
		showConditionalFields: false,
		offenderSearchResults: [],
		offenderApiUrl: null,
		DOCResponsible: [],
		loading: false,
		searchError: null,
	}
	componentWillMount() {
		const self = this;
		const stepData = this.props.stepData;
		if(!stepData.access) {
			this.props.previousStep(stepData);
		}
		this.props.setHeaderDisplay(
			this.state.heading,
      		stepData.displayStep,
			this.state.showProgressBar,
			this.state.pageId,
      		stepData.step,
      		this.state.badge
		);
		axios.post("VisitorApplication.aspx/GetOffenderApiUrl", {key: "key"})
			.then(res => {
				self.setState({offenderApiUrl: res.data.d})
			});
	}
	componentDidMount() {
		document.getElementById('root').scrollIntoView(true);
		window.scrollBy(0, -10);	
	}
	handleConditionalClick = () => {
		const toggle = !this.state.showConditionalFields;
		this.setState({showConditionalFields: toggle})
	}
	handleOffenderSearch = () => {
		if(!this.validateSearchForm()) {
			this.setState({loading: true});
			const url = this.state.offenderApiUrl;
			const fields = this.props.fields;
			let formattedDate;
			if(!(DateUtils.isDate(fields.offenderSearchReleaseDate.value))) {
				formattedDate = null;
			} else {
				formattedDate = moment(fields.offenderSearchReleaseDate.value).format('L');
			}
			const offenderSearch = {
				OffenderId: parseInt(fields.offenderSearchId.value, 10) || null,
				FirstNameLowercase: fields.offenderSearchFirstName.value.toLowerCase(),
				LastNameLowercase: fields.offenderSearchLastName.value.toLowerCase(),
				MiddleNameLowercase: fields.offenderSearchMiddleName.value.toLowerCase() || null,
				ReleaseDate: formattedDate,
				AgeFrom: fields.offenderSearchAgeFrom.value || null,
				AgeTo: fields.offenderSearchAgeTo.value || 99,
				Race: this.props.getOptionName(fields.offenderSearchRace, fields.offenderSearchRace.value) || null,
				Alias: fields.offenderSearchAlias.value.toLowerCase() || null,
				Gender: this.props.getOptionName(fields.offenderSearchSex, fields.offenderSearchSex.value) || null,
			}
			// output search
			//console.log(offenderSearch);
			axios.post(url, offenderSearch)
			.then(res => {
				// output results
				//console.log(res.data);
				const DOCResponsible = res.data.filter(x => x.DOCResponsible === "1" && x.LocationType === "Adult Facility/Institution");
				if(DOCResponsible.length > 0) {
					this.setState({
						offenderSearchResults: res.data,
						loading: false,
						DOCResponsible: DOCResponsible,
						searchError: null,
					})
				} else {
					this.setState({
						offenderSearchResults: res.data,
						loading: false,
						DOCResponsible: DOCResponsible,
						searchError: "No inmate match was found using the information which was provided",
					})
				}
				const fieldNames = Object.keys(fields);
				fieldNames.map(name => {
					if(name === 'offenderSearchAgeFrom') {
						this.props.clearInput(name, 18);	
					} else if(name === 'offenderSearchAgeTo') {
						this.props.clearInput(name, 99);
					} else {
						this.props.clearInput(name);
					}
					return name;
				})
				document.getElementById('visitation-search-results').scrollIntoView();
			})
			.catch((err) => {
				const message = err.response 
					? err.response.data.Message
					: "The inmate locator is temporarily unavailable. Please try again later."
				const fieldNames = Object.keys(fields);
				fieldNames.map(name => {
					if(name === 'offenderSearchAgeFrom') {
						this.props.clearInput(name, 18);	
					} else if(name === 'offenderSearchAgeTo') {
						this.props.clearInput(name, 99);
					} else {
						this.props.clearInput(name);
					}
					return name;
				})
				document.getElementById('visitation-search-results').scrollIntoView()
				this.setState({
					offenderSearchResults: [],
					loading: false,
					DOCResponsible: [],
					searchError: message,
				});
			});
		} else {
			this.scrollToError();
		}
	}
	validateSearchForm = () => {
		const fields = this.props.fields;
		const offenderId = fields.offenderSearchId.value;
		const firstName = fields.offenderSearchFirstName.value;
		const lastName = fields.offenderSearchLastName.value;
		const fieldsToBeValidated = [];
		let isErr = false;
		this.props.clearErrors(Object.keys(fields));

		if(!offenderId) {
			fieldsToBeValidated.push("offenderSearchFirstName");
			fieldsToBeValidated.push("offenderSearchLastName");
		}
		if(!firstName && !lastName) {
			fieldsToBeValidated.push("offenderSearchId");
		}
		if(this.props.validateStep(fieldsToBeValidated) || (!firstName && !lastName && !offenderId)) {
			isErr = true;
		}
		return isErr;
	}
	scrollToError = () => {
		const fields = this.props.fields;
		let errFields = [];
		Object.keys(fields).map((fieldName) => {
			if(fields[fieldName].className === "input-err") {
				errFields.push(fieldName);
			}
			return fieldName;
		})
		const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
		if (firstErr) {
			firstErr.scrollIntoView();
		}
	}
	addOffender = (id) => {
		const stepData = this.props.stepData;
		let offenderToAdd;
		this.state.DOCResponsible.map(offender => {
			if(offender.OffenderId === id) {
				offenderToAdd = offender;
			}
			return offender;
		})
		this.props.saveOffender(offenderToAdd);
		this.props.nextStep(stepData)
	}
	render() {
		const fields = this.props.fields;
		const DOCResponsible = this.state.DOCResponsible;
		const error = this.state.searchError;
		const loading = this.state.loading;
		return(
			<div className="col-19">
				{loading ? (
					<LoadingIndicator />
				) : (false)}
				<p className="description">Use the search tool to locate the inmate you want to visit, and add them to your application.</p>
				<form 
					className="visitation-form" 
					id="offender-to-visit"
					onSubmit={(e) => this.handleOffenderSearch}>
					<fieldset>
						<h3>Required Information</h3>
						<p>You must either enter the first and last name of the inmate or their VADOC-assigned Inmate ID#.</p>
						<TextInput 
							label={fields.offenderSearchFirstName.label}
				            className={fields.offenderSearchFirstName.className}
				            value={fields.offenderSearchFirstName.value}
				            name="offenderSearchFirstName"
				            required={fields.offenderSearchFirstName.isRequired}
				            placeholder={fields.offenderSearchFirstName.placeholder}
				            errMessage={fields.offenderSearchFirstName.errMessage}
				            onChange={this.props.handleInputChange}
				            id="offenderSearchFirstName" />
						<TextInput 
							label={fields.offenderSearchLastName.label}
				            className={fields.offenderSearchLastName.className}
				            value={fields.offenderSearchLastName.value}
				            name="offenderSearchLastName"
				            required={fields.offenderSearchLastName.isRequired}
				            placeholder={fields.offenderSearchLastName.placeholder}
				            errMessage={fields.offenderSearchLastName.errMessage}
				            onChange={this.props.handleInputChange}
				            id="offenderSearchLastName" />
			            <div className="or-divider col-1">
							<div className="vertical-line"></div>
							<p>or</p>
							<div className="vertical-line"></div>
						</div>
						<TextInput 
							label={fields.offenderSearchId.label}
				            className={fields.offenderSearchId.className}
				            value={fields.offenderSearchId.value}
				            name="offenderSearchId"
				            required={fields.offenderSearchId.isRequired}
				            placeholder={fields.offenderSearchId.placeholder}
				            errMessage={fields.offenderSearchId.errMessage}
				            onChange={this.props.handleInputChange}
				            id="offenderSearchId" />
				        <div className="search-options"> 
							{this.state.showConditionalFields ? (false) : (
								<PrimaryButton 
									id="offender-search-button"
									label="Search"
									handleClick={this.handleOffenderSearch} 
									className="primary-button" 
									disabled={this.state.loading} />
							)}
							<PrimaryButton 
								id="show-optional-offender-info"
								label="Show more search options"
								className="link-style" 
								handleClick={this.handleConditionalClick} />
						</div>
					</fieldset>
					{this.state.showConditionalFields ? (
						<fieldset id="optional-offender-info">
							<h3>Optional Information</h3>
							<TextInput 
								label={fields.offenderSearchMiddleName.label}
					            className={fields.offenderSearchMiddleName.className}
					            value={fields.offenderSearchMiddleName.value}
					            name="offenderSearchMiddleName"
					            placeholder={fields.offenderSearchMiddleName.placeholder}
					            errMessage={fields.offenderSearchMiddleName.errMessage}
					            onChange={this.props.handleInputChange}
					            id="offenderSearchMiddleName" />
					        <TextInput 
								label={fields.offenderSearchAlias.label}
					            className={fields.offenderSearchAlias.className}
					            value={fields.offenderSearchAlias.value}
					            name="offenderSearchAlias"
					            placeholder={fields.offenderSearchAlias.placeholder}
					            errMessage={fields.offenderSearchAlias.errMessage}
					            onChange={this.props.handleInputChange}
					            id="offenderSearchAlias" />
					        <DateField 
								handleDateInput={this.props.handleDateInput}
								name="offenderSearchReleaseDate"
								className={fields.offenderSearchReleaseDate.className}
								formatDate={this.props.formatDate}
								parseDate={this.props.parseDate}
								errMessage={fields.offenderSearchReleaseDate.errMessage}
								label={fields.offenderSearchReleaseDate.label} />
							<DualRangeInput
								className="offenderSearchAgeRange"
								label="Age Range" 
								fromName="offenderSearchAgeFrom" 
								fromLabel={fields.offenderSearchAgeFrom.label}
								toName="offenderSearchAgeTo"
								toLabel={fields.offenderSearchAgeTo.label}
								min="18"
								max="99"
								handleInputChange={this.props.handleInputChange} />
							<SelectInput
								options={SelectFieldOptions.race}
								className={fields.offenderSearchRace.className}
								value={fields.offenderSearchRace.value}
								name="offenderSearchRace"
								id="offenderSearchRace"
								label={fields.offenderSearchRace.label}
								errMessage={fields.offenderSearchRace.errMessage}
								onChange={this.props.handleInputChange} />
							<SelectInput
								value={fields.offenderSearchSex.value}
								options={SelectFieldOptions.sex}
								className={fields.offenderSearchSex.className}
								name="offenderSearchSex"
								id="offenderSearchSex"
								label={fields.offenderSearchSex.label}
								errMessage={fields.offenderSearchSex.errMessage}
								onChange={this.props.handleInputChange} />
							<RangeSlider 
								title="Age Range"
								minName="offenderSearchAgeFrom"
								maxName="offenderSearchAgeTo"
								handleSliderChange={this.props.handleSliderChange}
								minValue={fields.offenderSearchAgeFrom.value}
								maxValue={fields.offenderSearchAgeTo.value} />
							<PrimaryButton 
								label="Search"
								className="primary-button" 
								handleClick={this.handleOffenderSearch} 
								disabled={this.state.loading} />
						</fieldset>
					) : (
						false
					)}
				</form>
				<div id="visitation-search-results">
					{DOCResponsible.length > 0 ? (
						<React.Fragment>
							<h3>Search Results</h3>
							<ul className="visitation-result-cards">
								{this.state.DOCResponsible.map(result => (
									<OffenderResultCard 
										key={result.OffenderId}
										offenderId={result.OffenderId}
										fullName={result.FullName}
										age={result.Age}
										race={result.Race}
										gender={result.Gender}
										alias={result.AliasFull}
										locationName={result.LocationName}
										projectedReleaseDate={result.ProjectedReleaseDate}
										addOffender={this.addOffender} />
								))}
							</ul>
						</React.Fragment>
					) : (false)}
					{error ? (
						<ErrorDisplay 
							message={this.state.searchError} /> 
					) : (false)}
				</div>
			</div>
		)
	}
}

export default OffenderToVisit;


// WEBPACK FOOTER //
// ./src/pages/OffenderToVisit/OffenderToVisit.js